module.exports = __webpack_public_path__ + "media/assets/images/arrow_down-e078f4c9445a20d266989648e1577041.svg";